import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { formatWithDecimal } from '../../../utilities/formatHelpers';

const TransferFeeItem = (props) => {
  const { value, description, unit, suffix } = props;

  return (
    <div className="d-flex flex-column flex-fill w-50 mb-2">
      <span className="fw-bolder" style={{ fontSize: '1.375rem' }}>
        {unit === '%' ? `${value}%${suffix || ''}` : `${value} ${unit}`}
      </span>
      <span className="text-f6 text-shadow fw-light">{description}</span>
    </div>
  );
};

TransferFeeItem.propTypes = {
  suffix: PropTypes.string,
};
TransferFeeItem.defaultProps = {
  suffix: null,
};

const TransferFees = ({
  userCurrency,
  conversionFee,
  monthlyPurchaseFee,
  withdrawalNetworkFee,
  cryptoToFiatFee,
}) => {
  const { t: translate } = useTranslation();

  return (
    <div className="d-flex flex-row flex-wrap">
      <TransferFeeItem
        value={formatWithDecimal(monthlyPurchaseFee, 2)}
        unit={userCurrency}
        description={
          <span>
            {translate('transfer_fee_item_1_1')}
            <br />
            {translate('transfer_fee_item_1_2')}
          </span>
        }
      />

      <TransferFeeItem
        value={formatWithDecimal(withdrawalNetworkFee, 2)}
        unit={userCurrency}
        description={
          <span>
            {translate('transfer_fee_item_2_1')}
            <br />
            {translate('transfer_fee_item_2_2')}
          </span>
        }
      />

      <TransferFeeItem
        value={formatWithDecimal(conversionFee, 1)}
        unit="%"
        description={translate('transfer_fee_item_3')}
      />

      <TransferFeeItem
        value={formatWithDecimal(cryptoToFiatFee, 1)}
        unit="%"
        suffix="*"
        description={translate('transfer_fee_item_4')}
      />
    </div>
  );
};

TransferFees.propTypes = {
  userCurrency: PropTypes.string.isRequired,
  conversionFee: PropTypes.number.isRequired,
  monthlyPurchaseFee: PropTypes.number.isRequired,
  withdrawalNetworkFee: PropTypes.number.isRequired,
  cryptoToFiatFee: PropTypes.number.isRequired,
};

TransferFeeItem.propTypes = {
  value: PropTypes.number.isRequired,
  unit: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default TransferFees;
